import { ALERT_SIZE, HcpAlert, SEVERITY } from '@hmhco/hcp-alert/src/index';
import React, { useState } from 'react';
import { usePlatform, PLATFORMS } from '@hmhco/platform-helper';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getLoginStep } from '../../../../store/selectors/TenantPickerState';

/**
 * Should only be used for NWEA since they will need to reset password
 *
 */
const NweaAlert = () => {
  const [show, setShow] = useState(true);
  const { formatMessage } = useIntl();
  const platform = usePlatform();
  const loginStep = useSelector(getLoginStep);

  if (platform !== PLATFORMS.NWEA || loginStep !== 2 || !show) {
    return null;
  }

  return (
    <div id="nwea-alert" data-testid="nwea-alert">
      <HcpAlert
        size={ALERT_SIZE.SMALL}
        severity={SEVERITY.INFO}
        title=""
        subtitle={formatMessage({ id: 'nwea.login.message' })}
        onClose={() => setShow(false)}
      />
    </div>
  );
};

export default NweaAlert;
